NtechApp.WorkingHoursForm = function($view) {
    var me = this;

    this._$view = null;
    this._click = null;

    this._workingHoursForm = null;
    this._$workingHoursForm = null;

    this._dayRadios = null;
    this._$fromHoursInput = null;
    this._$toHoursInput = null;

    this._fromHoursAuto = null;
    this._toHoursAuto = null;

    this._construct = function () {
        me._$view = $view;
        me._click = new NtechApp.TouchClickEvent();

        me._workingHoursForm = new NtechApp.ModalForm(NtechApp.ModalForm.CACHE);
        me._workingHoursForm.setFormView($("#workingHoursForm"));
        me._$workingHoursForm = $("body").find("#workingHoursForm");

        me._dayRadios = NtechApp.formManager.getSerializedCheckboxById("dayRadiosGrid");
        me._dayRadios.updateHidden();

        me._$fromHoursInput = me._$workingHoursForm.find("#fromHours");
        me._$toHoursInput = me._$workingHoursForm.find("#toHours");

        me._fromHoursAuto = new NtechApp.Autocomplete(
            me._$fromHoursInput,
            NtechApp.merge(
                NtechApp.autocompleteSettings.default,
                {matchType: NtechApp.Autocomplete.MATCH_TYPES.START}
            ),
            function() { me._loadFromHours.apply(me, arguments); }
        );

        me._toHoursAuto = new NtechApp.Autocomplete(
            me._$toHoursInput,
            NtechApp.merge(
                NtechApp.autocompleteSettings.default,
                {matchType: NtechApp.Autocomplete.MATCH_TYPES.START}
            ),
            function() { me._loadToHours.apply(me, arguments); }
        );

        me._fromHoursAuto.setModalCss();
        me._toHoursAuto.setModalCss();

        me._fromHoursAuto.setInputMobileOverlayCss({maxWidth: "35%"});
        me._toHoursAuto.setInputMobileOverlayCss({maxWidth: "35%"});

        me._disableAutocompletes();
        me._bindEvents();
        me._bindAutoEvents();
    }

    this._bindEvents = function () {
        $(me._dayRadios).on(NtechApp.SerializedCheckboxes.EVENT_VALUE_CHANGE, function() {
            //console.log("change");
        });

        me._click.listen($("body").find("#workingHoursCustomField"), ".addNewItemControl", function() {
            me._openForm();
        });

        me._click.listen(me._$workingHoursForm.find(".formHeader .close .button"), function() {
            me._closeForm();
        });

        me._click.listen(me._$workingHoursForm.find("[data-cancelBut]"), function() {
            me._closeForm();
        });

        me._click.listen(me._$workingHoursForm.find("[data-confirmBut]"), function() {
            me._closeForm();

            var fromHours = me._$workingHoursForm.find("[data-fromHoursVal]").text();
            var toHours = me._$workingHoursForm.find("[data-toHoursVal]").text();
            var dayValsStr = me._dayRadios.getVal();

            var dayVals = [];
            if(dayValsStr.length > 0) {
                dayVals = dayValsStr.split(",");
            }

            var dayShiftsData = [];
            for(var i = 0; i < dayVals.length; i++) {
                fromHours = fromHours.replace(/ /gi, '-');
                toHours = toHours.replace(/ /gi, '-');

                var shiftStr = dayVals[i] + "|" + fromHours + "|" + toHours;
                dayShiftsData.push(shiftStr);
            }

            $(me).trigger(NtechApp.WorkingHoursForm.EVENT_WORKING_HOURS_ADD, [dayShiftsData]);
        });
    }

    this._bindAutoEvents = function() {
        $(me._fromHoursAuto).on(NtechApp.Autocomplete.SELECT_EVENT, function(event, id, text, $searchResult) {
            me._setHours(text);
        });

        $(me._toHoursAuto).on(NtechApp.Autocomplete.SELECT_EVENT, function(event, id, text, $searchResult) {
            me._setHours(null, text);
        });
    }

    this._unbindEvents = function () {
    }

    this.destruct = function () {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.WorkingHoursForm.EVENT_WORKING_HOURS_ADD = "NtechApp.WorkingHoursForm.EventWorkingHoursAdd";

NtechApp.proto(NtechApp.WorkingHoursForm, {
    _setHours: function(fromHours, toHours) {
        var fromHours = fromHours || null;
        var toHours = toHours || null;

        if(fromHours != null)
            this._$workingHoursForm.find("[data-fromHoursVal]").text(fromHours);
        if(toHours != null)
            this._$workingHoursForm.find("[data-toHoursVal]").text(toHours);
    },

    _openForm: function() {
        var me = this;
        this._workingHoursForm.forceCacheCallback();
        this._setHours("9:00 am", "10:00 pm");

        var $all = this._$workingHoursForm.find("[data-checkboxVal='All']");
        if(!$all.find(".confirmBox .icon").hasClass("selectedBox")) {
            $all.find("[data-checkboxTrigger]").trigger("click");
        }

        this._workingHoursForm.load("fakeRoute", function() {
            me._enableAutocompletes();
        });
    },

    _closeForm: function() {
        this._workingHoursForm.unload();
        this._disableAutocompletes();
    },

    _enableAutocompletes: function() {
        this._fromHoursAuto.unforceInputMobileOverlayHide();
        this._toHoursAuto.unforceInputMobileOverlayHide();

        this._fromHoursAuto.resize();
        this._toHoursAuto.resize();
    },

    _disableAutocompletes: function() {
        this._fromHoursAuto.forceInputMobileOverlayHide();
        this._toHoursAuto.forceInputMobileOverlayHide();
    },

    _getSearchHour: function(searchVal) {
        if(searchVal.length == 0)
            return -1;

        if(searchVal.length == 1)
            return parseInt(searchVal, 10);

        var hour = searchVal[0] + searchVal[1];
        hour = parseInt(hour, 10);

        if(hour == 10 || hour == 11 || hour == 12)
            return hour;

        return parseInt(searchVal[0], 10);
    },

    _getAllSearchHoursWithMinutes: function(searchHour) {
        var options = [];
        var postfixes = [
            ":00 am", ":00 pm",
            ":30 am", ":30 pm",
            ":15 am", ":15 pm",
            ":45 am", ":45 pm"
        ];

        var addAllPostfixedOptionsForHour = function(searchHour) {
            for(var i = 0; i < postfixes.length; i++)
                options.push(searchHour + postfixes[i]);
        };

        if((searchHour >= 3 && searchHour <= 12) || searchHour == 0) {
            addAllPostfixedOptionsForHour(searchHour);
        }
        else {
            addAllPostfixedOptionsForHour(searchHour);
            // addAllFor 10/11?
        }

        return options;
    },

    _getOptionsHtml: function(options) {
        var html = "";
        for(var i = 0; i < options.length; i++) {
            var row = '';
            var val = options[i];

            row += '<div class="defaultRowResult searchResult"';
            row += '    data-searchResultId="' + val + '" data-searchResultText="' + val + '">';
            row += '   <div class="top">' + val + '</div>';
            //row += '   <div class="bottom">{{ result.sublabel }}</div>';
            row += '</div>';

            html += row;
        }

        return html;
    },

    // @todo -> Refactor next 2 fns in one shared?
    _loadFromHours: function(searchVal, onFoundData, onNotFoundData, page) { 
        var searchHour = this._getSearchHour(searchVal);
        if(searchHour === -1) {
            onNotFoundData();
            return;
        }

        var options = this._getAllSearchHoursWithMinutes(searchHour);
        var optionsHtml = this._getOptionsHtml(options);
        
        onFoundData(optionsHtml);
    },

    _loadToHours: function(searchVal, onFoundData, onNotFoundData, page) {
        var searchHour = this._getSearchHour(searchVal);
        if(searchHour === -1) {
            onNotFoundData();
            return;
        }

        var options = this._getAllSearchHoursWithMinutes(searchHour);
        var optionsHtml = this._getOptionsHtml(options);
        
        onFoundData(optionsHtml);
    }
});